import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontWeight, Heading, LiliLink, LiliLinkSize, Text } from '@lili/lili-frontend-common';
import { ReactComponent as CalendarIcon } from '../../../assets/icons/svg/colored-icons/ic-colored-calendar.svg';
import { ReactComponent as CashIcon } from '../../../assets/icons/svg/colored-icons/ic-colored-cash.svg';
import { ReactComponent as BankIcon } from '../../../assets/icons/svg/colored-icons/ic-colored-bank-small.svg';
import { ReactComponent as GraphIcon } from '../../../assets/icons/svg/colored-icons/ic-colored-graph.svg';
import { ReactComponent as NoFeeIcon } from '../../../assets/icons/svg/colored-icons/ic-colored-no-fee.svg';

const BalanceUpDashboardSubContent = () => {
  const { t } = useTranslation('balanceUpTranslation');

  return (
    <div className='flex flex-col w-[400px] h-full'>
      <Heading.H5 fontWeight={FontWeight.SEMIBOLD} className='mb-[16px]'>
        {t('PRESERVE_ELIGIBILITY.TITLE')}
      </Heading.H5>
      <div className='flex flex-col justify-between h-full'>
        <div className='flex flex-col gap-[24px]'>
          <div className='flex gap-[6px] items-center'>
            <CalendarIcon className='w-[32px] h-[32px] shrink-0' />
            <Text.H10>{t('PRESERVE_ELIGIBILITY.RENEWAL')}</Text.H10>
          </div>
          <div className='flex gap-[6px] items-center'>
            <CashIcon className='w-[32px] h-[32px] shrink-0' />
            <Text.H10>{t('PRESERVE_ELIGIBILITY.MIN_DEPOSIT')}</Text.H10>
          </div>
          <div className='flex gap-[6px] items-center'>
            <BankIcon className='w-[32px] h-[32px] shrink-0' />
            <Text.H10>{t('PRESERVE_ELIGIBILITY.AVAILABILITY')}</Text.H10>
          </div>
          <div className='flex gap-[6px] items-center'>
            <GraphIcon className='w-[32px] h-[32px] shrink-0' />
            <Text.H10>{t('PRESERVE_ELIGIBILITY.USAGE')}</Text.H10>
          </div>
          <div className='flex gap-[6px] items-center'>
            <NoFeeIcon className='w-[32px] h-[32px] shrink-0' />
            <Text.H10>{t('PRESERVE_ELIGIBILITY.NO_FEES')}</Text.H10>
          </div>
        </div>
        <div className='flex flex-row items-baseline'>
          <Text.H10 className='mt-[24px] text-text-main-secondary'>{t('PRESERVE_ELIGIBILITY.MORE_INFO')}</Text.H10>
          <span className='ml-[4px]'>
            <LiliLink
              id='learn-more'
              href='https://support.lili.co/hc/en-us/search?utf8=%E2%9C%93&query=BalanceUp'
              target='_blank'
              title={t('PRESERVE_ELIGIBILITY.LEARN_MORE')}
              size={LiliLinkSize.SMALL}
            />
          </span>
        </div>
      </div>
    </div>
  );
};

export default BalanceUpDashboardSubContent;
